export default __webpack_public_path__ + "static/media/lesson_work_flow.a6c74084.png";